export const MULTIFAMILY_NUMERIC_FIELDS = [
  'totalUnits',
  'avgUnitSizeMt',
  'avgUnitSizeSf',
  'unitsZeroBed',
  'unitsOneBed',
  'unitsTwoBed',
  'unitsThreeBed',
];
